var map = {
	"./addBookmark.svg": "86e6",
	"./addCollection.svg": "0310",
	"./article.svg": "2bdb",
	"./bookmark.svg": "7253",
	"./collection.svg": "3539",
	"./column.svg": "5b82",
	"./exchange.svg": "3edd",
	"./home.svg": "ac9d",
	"./manage.svg": "54fd",
	"./menu.svg": "d17f",
	"./menuItem.svg": "efa8",
	"./setup.svg": "468b",
	"./star.svg": "cc90",
	"./tag.svg": "81fd",
	"./tag2.svg": "b3d9",
	"./tool.svg": "b323",
	"./type.svg": "fa90",
	"./write.svg": "9ed1",
	"./专栏管理.svg": "d4fb",
	"./文章管理.svg": "fb4d",
	"./验收标签管理.svg": "88ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";